import { configureStore } from '@reduxjs/toolkit'
import globalReducer from './global/globalSlice'
import shippingReducer from './shipping/shippingSlice'
import recipientReducer from './recipient/recipientSlice'

export default configureStore({
  reducer: {
    global: globalReducer,
    shipping: shippingReducer,
    recipient: recipientReducer,
  },
})
